import { render, staticRenderFns } from "./RecentBlocks.vue?vue&type=template&id=5b47fc10&scoped=true"
import script from "./RecentBlocks.vue?vue&type=script&lang=js"
export * from "./RecentBlocks.vue?vue&type=script&lang=js"
import style0 from "./RecentBlocks.vue?vue&type=style&index=0&id=5b47fc10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47fc10",
  null
  
)

export default component.exports